{
  "es": {
    "dashboard": {
      "greetings": {
        "afternoon": "Buenas tardes, {first_name}",
        "evening": "Buenas noches, {first_name}",
        "morning": "Buenos días, {first_name}",
        "night": "Buenas noches, {first_name}"
      },
      "milestones": {
        "action_title_decision": "Elige {name}",
        "action_title_survey": "Responde {name}",
        "action_title_ticket": "Nuevo mensaje sobre {name}",
        "count_open": "{count} pendientes",
        "journey_hide": "Ocultar el recorrido del proyecto",
        "journey_show": "Ver el recorrido del proyecto",
        "journey_step_active": "En curso",
        "journey_step_completed": "Completada",
        "journey_step_planned": "Planificada",
        "other_empty_subtitle": "{client} te avisará en cuanto haya algo para ti.",
        "other_empty_title": "Estás al día",
        "other_promoted_title": "Necesita tu atención",
        "other_title": "Otras acciones",
        "stage_done_subtitle": "{client} te avisará cuando llegue el siguiente paso.",
        "stage_done_title": "Todo listo para esta fase",
        "stage_empty": "Ahora mismo no hay nada que hacer en esta fase.",
        "stage_eyebrow": "Fase actual",
        "stage_final_subtitle": "Todos los pasos de tu proyecto están terminados. Te mantendremos al día si algo cambia.",
        "stage_final_title": "Has terminado del todo",
        "stage_last": "Esta es la última fase",
        "stage_next": "A continuación: {phase}",
        "stage_position": "Fase {current} de {total}",
        "stage_todo_title": "Para completar esta fase"
      },
      "titles": {
        "activityFeed": "Actividad reciente",
        "assignedTasks": "Mis tareas",
        "newsFeed": "Novedades",
        "ongoingTickets": "En curso",
        "openTickets": "Abiertas",
        "progress": "Progreso",
        "tickets": "Conversaciones",
        "totalTickets": "Todas las conversaciones",
        "unreadTickets": "Sin leer",
        "yourAssignedTickets": "Asignadas a ti"
      }
    }
  }
}
